import React, { useState } from 'react';
import { Container, Row, Col, Button, Form, FormGroup, Input } from 'reactstrap';
import { withRouter } from "react-router-dom";

function Contactcontent(props) {
  const [success, setSuccess] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const sendMessage = (e) => {
    e.preventDefault();
    const userData = { firstName, lastName, email, message };
    fetch('/userData', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "POST",
      body: JSON.stringify(userData)
    }).then(res => {
      res.json().then(res => {
        if (res.error) {
          alert("Internal server error, please try later.");
        } else {
          setSuccess(true);
          setTimeout(() => {
            props.history.push("/view");
          }, 2000);
        }
      });
    });
  };

  return (
    <div className="career-content-section">
      <Container fluid>
        <Row>
          <Col className="mt-60">
            <h2 className="text-center head"> Reach Us</h2>
            <p className="head-black text-center m-20 pno">
              Systematrix envisions simplifying business processes with advanced Algorithmic models.
              Our team is motivated to delve deep into Data Science to create cutting edge products.
            </p>
          </Col>
        </Row>
        <Row className="mtop-5">
          <Col lg={{ size: 9, offset: 2 }} md="12">
            <Row>
              <Col md="6">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3441.724640908284!2d-97.7621328252088!3d30.387176074752848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644cb0beac14071%3A0xc8a4a0d772d3657b!2sOffice%20Evolution%20-%20Austin%20Arboretum%2C%20TX!5e0!3m2!1sen!2sin!4v1766410650107!5m2!1sen!2sin"
                  width="600"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  id="contact-map"
                  className="map-style"
                  display="initial"
                  position="relative"
                  frameBorder="0"
                  aria-hidden="false"
                  tabIndex="0"
                  title="Systematrix Location"
                />
              </Col>

              <Col md="6">
                <div className="address">
                  <h3>Systematrix Solutions</h3>
                  <p>Austin Arboretum Office Evolution,</p>
                  <p>#8911 North Capital of Texas Highway, Austin, TX.</p>
                  <p className="mt-5"> Phone:(+1) 614-678-4343</p>
                  <p>Email: contact@systematrix.ai</p>
                </div>
                <div className="contact-form">
                  <h3 className="text-orange ">Talk to our Experts</h3>
                  <Form onSubmit={sendMessage}>
                    <div className={success ? "hide" : ""}>
                      <FormGroup>
                        <Input
                          type="text"
                          name="firstName"
                          placeholder="First Name"
                          className="text-field"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                          required
                        />
                      </FormGroup>
                      <FormGroup>
                        <Input
                          type="text"
                          name="lastName"
                          placeholder="Last Name"
                          className="text-field"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                          required
                        />
                      </FormGroup>
                      <FormGroup>
                        <Input
                          type="email"
                          name="email"
                          placeholder="Email"
                          className="text-field"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </FormGroup>
                      <FormGroup>
                        <Input
                          type="textarea"
                          name="message"
                          className="text-field custom-text-area"
                          placeholder="Enter Message (Optional)"
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                        />
                      </FormGroup>
                      <div className="text-center">
                        <Button
                          type="submit"
                          color="primary"
                          size="lg"
                          className="rounded btn-pad"
                        >
                          Send Message
                        </Button>
                      </div>
                    </div>

                    <div className={success ? "" : "hide"}>
                      <div className="text-center">
                        <i className="fa fa-check-circle fa-5x check-icon" aria-hidden="true"></i>
                        <h2 className="success-msg">Your message has been submitted Successfully</h2>
                      </div>
                    </div>
                  </Form>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default withRouter(Contactcontent);